var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7CFB\\u7EDFUI\\u754C\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7403\\u9986\\u4FE1\\u606F",
    transform: "translate(-24.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.Navigation\\u5BFC\\u822A/4.Menu-\\u5BFC\\u822A\\u83DC\\u5355/\\u5E73\\u94FA\\u5F0F\\u4FA7\\u8FB9\\u5BFC\\u822A/\\u56FE\\u6807\\u5907\\u4EFD",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.Navigation\\u5BFC\\u822A/4.Menu-\\u5BFC\\u822A\\u83DC\\u5355/\\u57FA\\u7840\\u63A7\\u4EF6/\\u5DE6\\u4FA7\\u5BFC\\u822A/\\u4E00\\u7EA7\\u9009\\u4E2D",
    transform: "translate(8.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.Bace\\u57FA\\u7840/3.Icon\\u56FE\\u6807/\\u5176\\u4ED6/server",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 L20,20 L0,20 L0,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0.0000999999975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.622508,5.59195828 L13.7000275,6.51443815 C12.5902987,5.94582021 11.3326149,5.625 10,5.625 C5.61023664,5.625 2.03356183,9.10624504 1.88012874,13.4585819 L1.875,13.75 L0.625,13.75 C0.625,8.57233047 4.82233047,4.375 10,4.375 C11.6808357,4.375 13.258358,4.81733888 14.622508,5.59195828 Z M17.2355614,10.0499721 L18.158041,9.12749195 C18.8858738,10.4092469 19.3203545,11.8793774 19.3701839,13.4465866 L19.375,13.75 L18.125,13.75 C18.125,12.4173851 17.8041801,11.1597013 17.2355614,10.0499721 Z M17.5130081,5.35310698 L9.55805779,13.3080578 L10.4419413,14.1919422 L18.3968925,6.23699045 L17.5130081,5.35310698 Z",
    id: "dashboard",
    fillOpacity: 0.9,
    fill: "currentColor"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.b5194a94b6009b95111a2c2cc70a2fa5.svg";
export { ForwardRef as ReactComponent };